var SupportEditOrderServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportEditOrderServiceActionView = (function(superClass) {
  extend(SupportEditOrderServiceActionView, superClass);

  function SupportEditOrderServiceActionView() {
    return SupportEditOrderServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportEditOrderServiceActionView.prototype.id = 'edit_order';

  SupportEditOrderServiceActionView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    return this.order = Groupon.Support.currentOrder;
  };

  SupportEditOrderServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportEditOrderServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "edit_order",
      service_action: I18n.t("js.modules.support.edit_order")
    };
    return this.extendHash(hash);
  };

  SupportEditOrderServiceActionView.prototype.actionHandler = function(event) {
    var current_order, dealPermalink, orderId, url;
    current_order = Groupon.Support.currentOrder;
    dealPermalink = current_order.deal.id;
    orderId = current_order.id;
    url = "/deals/" + dealPermalink + "/confirmation/" + orderId;
    return window.open(url);
  };

  SupportEditOrderServiceActionView.prototype.events = {
    "click #edit_order": "actionHandler"
  };

  return SupportEditOrderServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportEditOrderServiceActionView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvZWRpdF9vcmRlcl9zZXJ2aWNlX2FjdGlvbi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9vcmRlcl9yZWxhdGVkL3NlcnZpY2VfYWN0aW9ucy9lZGl0X29yZGVyX3NlcnZpY2VfYWN0aW9uLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLG9HQUFBO0VBQUE7OztBQUFBLDZCQUFBLEdBQWdDLE9BQUEsQ0FBUSx1QkFBUjs7QUFDaEMsa0NBQUEsR0FBcUMsT0FBQSxDQUFRLGlEQUFSOztBQUUvQjs7Ozs7Ozs4Q0FDSixFQUFBLEdBQUk7OzhDQUVKLFVBQUEsR0FBWSxTQUFBO0lBQ1YsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7SUFDWixDQUFDLENBQUMsT0FBTyxDQUFDLEtBQVYsQ0FBZ0IsQ0FBaEIsRUFBbUIsQ0FBQyxJQUFELENBQU0sQ0FBQyxNQUFQLENBQWMsQ0FBQyxDQUFDLFNBQUYsQ0FBWSxJQUFaLENBQWQsQ0FBbkI7V0FDQSxJQUFDLENBQUEsS0FBRCxHQUFTLE9BQU8sQ0FBQyxPQUFPLENBQUM7RUFKZjs7OENBTVosTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFsQixFQUE2QixJQUFDLENBQUEsU0FBOUIsQ0FBWjtFQURNOzs4Q0FHUixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFBLEdBQ0U7TUFBQSxpQkFBQSxFQUFvQixZQUFwQjtNQUNBLGNBQUEsRUFBaUIsSUFBSSxDQUFDLENBQUwsQ0FBTywrQkFBUCxDQURqQjs7V0FFRixJQUFDLENBQUEsVUFBRCxDQUFZLElBQVo7RUFKTTs7OENBTVIsYUFBQSxHQUFlLFNBQUMsS0FBRDtBQUNiLFFBQUE7SUFBQSxhQUFBLEdBQWdCLE9BQU8sQ0FBQyxPQUFPLENBQUM7SUFFaEMsYUFBQSxHQUFnQixhQUFhLENBQUMsSUFBSSxDQUFDO0lBQ25DLE9BQUEsR0FBVSxhQUFhLENBQUM7SUFDeEIsR0FBQSxHQUFNLFNBQUEsR0FBVyxhQUFYLEdBQTBCLGdCQUExQixHQUEyQztXQUNqRCxNQUFNLENBQUMsSUFBUCxDQUFZLEdBQVo7RUFOYTs7OENBUWYsTUFBQSxHQUNFO0lBQUEsbUJBQUEsRUFBc0IsZUFBdEI7Ozs7O0dBM0I0Qzs7QUE2QmhELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
